import React, {useEffect} from "react";
import {LocaleProvider, useLocaleContext} from "@quiz/context/LocaleContext";
import QuizPanel from "@quiz/components/Quiz/QuizPanel";

const Preview = ({quiz, locale}) => {
    const {setLocaleName} = useLocaleContext();

    useEffect(() => {
        setLocaleName(locale);
    }, [locale]);

    return (
        <QuizPanel quiz={quiz} />
    );
}

export default ({quiz, locale = 'ru'}) => {
    return (
        <LocaleProvider>
            <Preview quiz={quiz} locale={locale} />
        </LocaleProvider>
    )
}
